import React from "react";

type Props = {
  icon: string;
  fill?: string;
  size?: number;
  className?: string;
  retainViewBox?: boolean;
};

export const SvgIcon: React.FC<Props> = ({
  icon,
  size = 25,
  className,
  retainViewBox,
}) => {
  return (
    <svg
      height={size}
      width={size}
      viewBox={retainViewBox ? `0 0 25 25` : `0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d={icon} className="stroke-0.5" />
    </svg>
  );
};
